import styled from 'styled-components';
import Input from 'components/Input';
import ButtonIcon from 'components/ButtonIcon';
import { GREY_300, GREY_400, GREY_50 } from '../../../constants';

export const SearchInput = styled(Input)`
    width: 100%;
    input {
        background: ${GREY_50};
        border-color: ${GREY_50};
    }
`;

export const MessagesListContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
`;

export const Messages = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 0.5rem;
    overflow-y: auto;
    padding-bottom: 2rem;
`;

export const ListHeader = styled.div`
    display: flex;
    width: 29.75rem;
    height: 3rem;
    padding-left: 0.5rem;
    justify-content: space-between;
    align-items: center;
`;

export const ListTitle = styled.h3`
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.625rem
`;

export const MessageContainer = styled.div`
    display: flex;
    padding: 0.75rem 0.75rem 0.75rem 1rem;
    align-items: center;
    gap: 0.75rem;
    align-self: stretch;
    border-radius: 0.75rem;
    border: 1px solid #D7D7D9;
`;

export const MessageTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    flex: 1 0 0;
    overflow: hidden;
`;

export const MessageTitle = styled.h3`
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.5rem;
    flex-direction: row;
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export const MessageContent = styled.p`
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;
    text-overflow: ellipsis;
`;

export const MessageActions = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledButtonIcon = styled(ButtonIcon)`
    color: ${GREY_300};
`;

export const SegmentCount = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-style: italic;
    min-width: 1.3rem;
    height: 1.3rem;
    padding: 0 0.6rem;
    font-size: 0.5rem;
    font-weight: 600;
    color: ${GREY_400};
    background: linear-gradient(90deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 1rem;
    z-index: 2;
    flex-shrink: 0;
`;
